export default {
  sihuaLu: '록',
  sihuaQuan: '권',
  sihuaKe: '과',
  sihuaJi: '기',
} as const;
